import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'filters',
    path: 'priorities',
    viewPath: props.viewPath,
  })

  let priority = useDataValue({
    context: 'priority',
    viewPath: props.viewPath,
  })

  let priorities = useDataValue({
    context: 'filters',
    path: 'priorities',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let shouldRemove = priorities.some(({ id }) => id === priority.id)
    change([
      ...priorities.filter(({ id }) => id !== priority.id),
      ...(shouldRemove ? [] : [priority]),
    ])
  }
}

export function isChecked(priorities, priorityId) {
  return priorities.some(priority => priority.id === priorityId)
}
